import React, { PureComponent } from 'react';

import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import {
  CardAnalythic,
  RecommendationBox,
  RecommendationText,
  RecommendationsColumn,
  IconRecommendation,
  SpanRecommendation,
  RiskText
} from '../analythic.styled';
import FinancialConstraints from './financialConstraints/FinancialConstraints';
import CheckConstraints from './checkConstraints/CheckConstraints';
import Protest from './protest/Protest';
import AvoidConstraints from './avoidConstraints/AvoidConstraints';
import Block from '@bit/wavfichacerta.fichacerta.icons.block';
import ReportRecommendation from '@bit/wavfichacerta.fichacerta.icons.report-recommendation';
import Lawsuits from './lawsuits/Lawsuits';
import LawsuitsCriminais from './lawsuits/LawsuitsCriminais';

export default class LocationSection extends PureComponent {

  getRecommendations = () => {
    const { data } = this.props;

    if (data !== undefined && data !== null && (typeof data === "object" && Object.keys(data).length > 0)) {
      const searchKeys = ['restricoes_financeiras'];
      let recommendations = [];
      searchKeys.forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          recommendations = [...recommendations, ...data[key].recommendation];
        }
      });

      if (Array.isArray(recommendations) && recommendations.length > 0) {
        // Remove duplicates
        recommendations = recommendations.filter((rec, index) => recommendations.indexOf(rec) === index);
        return (
          <RecommendationBox>
            <BaseColumn xs={12} md={1} lg={1} xl={1}>
              <RecommendationText>Obs: </RecommendationText>
            </BaseColumn>
            <RecommendationsColumn xs={12} md={11} lg={11} xl={11}>
              {recommendations.map((item) => (
                <RecommendationText>
                  <IconRecommendation><ReportRecommendation /></IconRecommendation>
                  <SpanRecommendation>{item}</SpanRecommendation>
                </RecommendationText>
              ))}
            </RecommendationsColumn>
          </RecommendationBox>
        );
      }
    }
    return null;
  }

  render() {
    const { data } = this.props;
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    const productFcReport = pretendente.produtos.ativo.filter(produto => produto.id === 1 && produto.status !== 'INCLUIDO')
    const productFcEssencial = pretendente.produtos.ativo.filter(produto => produto.id === 3 && produto.status !== 'INCLUIDO')
    const productFcEmpresa = pretendente.produtos.ativo.filter(produto => produto.id === 4)
    const productFcBasico = pretendente.produtos.ativo.filter(produto => produto.id === 5)
    const productFcCompletaPF = pretendente.produtos.ativo.filter(produto => produto.id === 7 && produto.status !== 'INCLUIDO')
    const productFcCompletaPJ = pretendente.produtos.ativo.filter(produto => produto.id === 8 && produto.status !== 'INCLUIDO')
    const productFcScore = pretendente.produtos.ativo.filter(produto => produto.id === 9 && produto.status !== 'INCLUIDO')
    const productFcScoreAcoes = pretendente.produtos.ativo.filter(produto => produto.id === 10 && produto.status !== 'INCLUIDO')

    if (productFcReport.length) return null;
    if (productFcCompletaPF.length) return null;
    if (productFcScore.length) return null;
    if (productFcScoreAcoes.length) return null;
    if (productFcBasico.length && !productFcEssencial.length) return null;

    if(!('acoes_criminais' in this.props.data.laudo.restricoes_financeiras.result)) return null;
    if(this.props.data.laudo.restricoes_financeiras.result.acoes_criminais.info !== 'CONSTA') return null;

    return (
      <CardAnalythic
        title="AÇÕES CRIMINAIS (Réu)*" // AÇÕES DE DESPEJO E INADIMPLEMENTO DA LOCAÇÃO
        iconHeader={Block}
        iconLeft={true}
      >
        {/* <AvoidConstraints dataSource={this.props.data.laudo} />
        <FinancialConstraints dataSource={this.props.data.laudo} pretendente={pretendente} />
        <CheckConstraints dataSource={this.props.data.laudo} />
        <Protest dataSource={this.props.data.laudo} /> */}
        {/* <Lawsuits dataSource={this.props.data.laudo} hidenTitle /> */}
        <LawsuitsCriminais dataSource={this.props.data.laudo} color='color_purple_3' temFcBasicoSemReport={true} />
        <RiskText style={{fontStyle: 'italic', fontSize: 11, fontWeight: 500, color: '#152b4e'}}>*Buscas automatizadas que dependem da disponibilidade das fontes. Podem não refletir a totalidade de apontamentos do pesquisado. Buscas realizadas por {productFcEmpresa.length || productFcCompletaPJ.length ? 'CNPJ' : 'CPF'}, embora não seja afastada a possibilidade de homonimias. <span style={{color: '#fe4d36'}}>{this.props.data.laudo.restricoes_financeiras && this.props.data.laudo.restricoes_financeiras.alerta_acoes_riogrande_do_sul}</span></RiskText>
        {this.getRecommendations()}
      </CardAnalythic>
    );
  }
}
